import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import ep001 from '@/content/ep001';

const PremiereRecherchePage = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-content">
          <a href="/" className="navbar-logo" data-testid="navbar-logo">LE REGISTRE</a>
          <div className="navbar-menu">
            <a href="/" className="navbar-link" data-testid="home-link">Journal</a>
            {user ? (
              <div className="navbar-user" data-testid="user-menu">
                {user.picture && <img src={user.picture} alt={user.name} className="user-avatar" data-testid="user-avatar" />}
                <span className="user-name" data-testid="user-name">{user.name}</span>
                {user.subscription_status === 'premium' && (
                  <span className="premium-badge" data-testid="premium-badge">Accès étendu</span>
                )}
                <button onClick={logout} className="btn btn-outline" data-testid="logout-button">Déconnexion</button>
              </div>
            ) : (
              <button onClick={() => navigate('/')} className="btn btn-primary" data-testid="login-button">Se connecter</button>
            )}
          </div>
        </div>
      </nav>

      <div className="content-container">
        <article className="entry-page" data-testid="premiere-recherche">
          <div className="entry-breadcrumb" data-testid="entry-breadcrumb">
            Registre // Entrée {ep001.numero} — Première recherche
          </div>

          <h1 className="entry-title" data-testid="entry-title">{ep001.titre}</h1>

          <div className="entry-meta-row" data-testid="entry-meta">
            <span>{ep001.phase}</span>
            <span>{ep001.reference}</span>
            <span className="entry-meta-statut">{ep001.statut}</span>
          </div>

          <aside className="entry-protocol" data-testid="entry-protocol">
            <div className="entry-protocol-title">Protocole de lecture</div>
            <dl>
              <dt>Concept</dt>
              <dd>{ep001.protocole.concept}</dd>
              <dt>Ancrage</dt>
              <dd>{ep001.protocole.ancrage}</dd>
              <dt>Le geste</dt>
              <dd>{ep001.protocole.geste}</dd>
            </dl>
          </aside>

          <div className="entry-body" data-testid="entry-body">
            {ep001.paragraphes.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="entry-signature">— E. Voss</div>

          <div className="entry-cta" data-testid="entry-cta">
            <p className="entry-cta-text">La suite se consigne en continu.</p>
            <div className="hero-actions" style={{ marginBottom: 0 }}>
              <button onClick={() => navigate('/')} className="btn btn-primary" data-testid="entry-to-journal">
                Consulter le journal
              </button>
              {!user && (
                <button onClick={() => navigate('/')} className="btn btn-secondary" data-testid="entry-to-access">
                  Créer un accès observateur
                </button>
              )}
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default PremiereRecherchePage;
